import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import InstallPrompt from "@/pwa/InstallPrompt";
import { OfflineBanner } from "@/components/OfflineBanner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import FloatingFeedbackButton from "@/components/feedback/FloatingFeedbackButton";
import WhatsNew from "./pages/WhatsNew";
import ServerError from "./pages/ServerError";
import Index from "./pages/Index";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import CareerQuiz from "./pages/CareerQuiz";
import ComparePrograms from "./pages/ComparePrograms";
import Guidance from "./pages/Guidance";
import GuidanceDetail from "./pages/GuidanceDetail";
import About from "./pages/About";
import Ambassador from "./pages/Ambassador";
import AmbassadorMentor from "./pages/AmbassadorMentor";
import AmbassadorToolkit from "./pages/AmbassadorToolkit";
import Feedback from "./pages/Feedback";
import Welcome from "./pages/Welcome";
import CareersDigitalMarketingIntern from "./pages/CareersDigitalMarketingIntern";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ErrorBoundary>
          <OfflineBanner />
          <InstallPrompt />
          <FloatingFeedbackButton />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:id" element={<ProgramDetail />} />
            <Route path="/career-quiz" element={<CareerQuiz />} />
            <Route path="/compare" element={<ComparePrograms />} />
            <Route path="/guidance" element={<Guidance />} />
            <Route path="/guidance/:slug" element={<GuidanceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/ambassador" element={<Ambassador />} />
            <Route path="/ambassador/mentor" element={<AmbassadorMentor />} />
            <Route path="/ambassador/toolkit" element={<AmbassadorToolkit />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/beta" element={<Navigate to="/welcome" replace />} />
            <Route path="/500" element={<ServerError />} />
            <Route path="/careers/digital-marketing-intern" element={<CareersDigitalMarketingIntern />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/intern-applications" element={<Admin />} />
            <Route path="/admin/messages" element={<Admin />} />
            <Route path="/admin/maintenance" element={<Admin />} />
            <Route path="/admin/programs" element={<Admin />} />
            <Route path="/admin/feedback" element={<Admin />} />
            <Route path="/admin/beta" element={<Admin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </ErrorBoundary>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
